import { MouseEvent, useState } from "react"
import { useTranslation } from "react-i18next"
import { Menu, MenuItem } from "@mui/material"
import { RiAddLine } from "@remixicon/react"

import type { WidgetPaletteItem, WidgetType } from "@/types/dashboard"

interface DashboardRowDividerProps {
  /** 그리드 y 경계값 (0 = 최상단, 1 = row 1 뒤, ...) */
  y: number
  /** 픽셀 top 위치 */
  topPx: number
  /** 추가 가능한 위젯 목록 */
  paletteItems: WidgetPaletteItem[]
  /** 각 위젯 타입별 현재 인스턴스 수 (maxInstances 비교용) */
  instanceCounts: Record<WidgetType, number>
  onAdd: (item: WidgetPaletteItem, y: number) => void
}

export default function DashboardRowDivider({
  y,
  topPx,
  paletteItems,
  instanceCounts,
  onAdd,
}: DashboardRowDividerProps) {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <div
        className={`DashboardRowDivider ${open ? "DashboardRowDivider--menu-open" : ""}`}
        style={{ top: `${topPx}px` }}>
        <button className="DashboardRowDivider__button" onClick={handleClick} type="button">
          <RiAddLine size={16} />
        </button>
      </div>

      <Menu
        className="DashboardRowDividerMenu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}>
        {paletteItems.map((item) => {
          const count = instanceCounts[item.type] ?? 0
          const reachedMax = item.maxInstances !== undefined && count >= item.maxInstances
          return (
            <MenuItem
              key={item.type}
              disabled={reachedMax}
              onClick={() => {
                if (!reachedMax) {
                  onAdd(item, y)
                  handleClose()
                }
              }}>
              <RiAddLine size={16} />
              <span className="DashboardRowDividerMenu__label">{t(item.label)}</span>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
